export default {
  get: {
    method: 'get',
    url: '/statistics/template?key=KEY'
  },
  create: {
    method: 'post',
    url: '/statistics/template'
  },
  delete: {
    method: 'delete',
    url: '/statistics/template/ID'
  },
  updateTemplate: {
    method: 'put',
    url: '/statistics/template/ID'
  },
  getStatistic: {
    method: 'get',
    url: '/statistics/CLASS'
  },
  getAllStatistic: {
    method: 'get',
    url: '/statistics/template/all'
  },
  chooseStatisticTemplate: {
    method: 'get',
    url: '/statistics/template/choose/ID'
  },
  deleteChooseStatisticTemplate: {
    method: 'get',
    url: '/statistics/template/choose/delete'
  }
}
